export default __webpack_public_path__ + "static/media/vector.eb378e16.svg";